var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#009C19",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67929 9.76613C7.27398 9.39097 6.64129 9.41541 6.26613 9.82071C5.89097 10.226 5.91541 10.8587 6.32071 11.2339L7.67929 9.76613ZM9.70089 13L9.02161 13.7339C9.22276 13.9201 9.49151 14.0155 9.76504 13.9979C10.0386 13.9804 10.2929 13.8513 10.4686 13.6409L9.70089 13ZM14.6427 8.64086C14.9966 8.21689 14.9398 7.58628 14.5159 7.23234C14.0919 6.8784 13.4613 6.93518 13.1073 7.35914L14.6427 8.64086ZM6.32071 11.2339L9.02161 13.7339L10.3802 12.2661L7.67929 9.76613L6.32071 11.2339ZM10.4686 13.6409L14.6427 8.64086L13.1073 7.35914L8.93323 12.3591L10.4686 13.6409Z",
    fill: "#009C19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.55541f7e970110ce8d6379d20c144ff5.svg";
export { ForwardRef as ReactComponent };